export enum OwnershipType {
  Owner = 1,
  Tenant = 2,
}

export enum PlanType {
  BuildingProtection = 1,
  ContentProtection = 2,
  BuildingContentProtection = 3,
  LppsaA = 4,
  LppsaB = 5,
  LppsaC = 6,
}

export enum BuildingType {
  Landed = 1,
  NonLanded = 2,
}

export enum ConstructionType {
  FullBrick = 1,
  PartialBrick = 2,
  FullyWooden = 3,
  PartiallyWooden = 4,
}
